import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { class: "w100 pad40" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "centered fs20" }, "プラン変更", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "centered" }, "現在の契約が有料プランの場合、期間終了までは継続してご利用いただけます。", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "centered"
}
const _hoisted_14 = {
  class: "pinkBg rad4 fw600",
  style: {"padding":"4px 6px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "skyblue fs12" }, "※ クーポンは予告なく終了する可能性があります。あらかじめご了承ください。", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fw600 centered" }, "翌月のお見積り額", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = {
  class: "centered",
  style: {"margin-left":"20px","margin-top":"10px"}
}
const _hoisted_23 = { class: "mc" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", {
  class: "fs12 centered dgrey",
  width: "50"
}, "数量", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", {
  class: "fs12 centered dgrey",
  width: "30"
}, " ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("th", {
  class: "fs12 centered dgrey",
  width: "100"
}, "プラン", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("th", {
  class: "fs12 centered dgrey",
  width: "30"
}, " ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("th", {
  class: "fs12 centered dgrey",
  width: "160"
}, "お見積り金額", -1)
const _hoisted_29 = {
  class: "yu",
  style: {"padding-top":"8px","height":"40px"}
}
const _hoisted_30 = { class: "centered fs18 fw600 dgrey" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "centered fs18 fw600 dgrey" }, "×", -1)
const _hoisted_32 = { class: "centered fs18 fw600 dgrey" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { class: "centered fs18 fw600" }, "=", -1)
const _hoisted_34 = {
  class: "centered fs24 fw600 ddgrey",
  style: {"padding-left":"20px"}
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, "円(税別)", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fs11 fr" }, "※ ID数に応じて変動する場合があります。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { class: "fs11 fr" }, "※ ご契約日が月中の場合、来月初まで日割りでのご請求になります。"),
    /*#__PURE__*/_createElementVNode("div", { class: "clear" })
  ])
], -1)
const _hoisted_37 = { key: 2 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "fr grey fs11" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = { class: "centered w100" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 1,
  class: "fw600"
}
const _hoisted_46 = {
  key: 2,
  class: "fw600"
}
const _hoisted_47 = { key: 1 }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (_ctx.action && _ctx.action == `toFree`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
        : _createCommentVNode("", true),
      _hoisted_9,
      _hoisted_10,
      (_ctx.action && _ctx.action != `toFree`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            (_ctx.willChangePlan.applied_coupon)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, "限定クーポン適用中: " + _toDisplayString(_ctx.willChangePlan.coupon_name), 1),
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18
                ]))
              : _createCommentVNode("", true),
            _hoisted_19,
            _hoisted_20,
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("table", _hoisted_23, [
                _hoisted_24,
                _hoisted_25,
                _hoisted_26,
                _hoisted_27,
                _hoisted_28,
                _createElementVNode("tr", _hoisted_29, [
                  _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.willChangePlan.applied_coupon
                                        ? _ctx.willChangePlan.cost_estimate_next_period.quantity
                                        : _ctx.willChangePlan.id_num == 1
                                        ? _ctx.users.length
                                        : Math.ceil(_ctx.users.length / _ctx.willChangePlan.id_num)), 1),
                  _hoisted_31,
                  _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.willChangePlan.applied_coupon
                                        ? (
                                              _ctx.willChangePlan.cost_estimate_next_period.total_without_tax /
                                              _ctx.willChangePlan.cost_estimate_next_period.quantity
                                          ).toLocaleString()
                                        : _ctx.willChangePlan.amount.toLocaleString()), 1),
                  _hoisted_33,
                  _createElementVNode("td", _hoisted_34, [
                    _createTextVNode(_toDisplayString(_ctx.nextPeriodTotalCost()) + " ", 1),
                    _hoisted_35
                  ])
                ]),
                _hoisted_36
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.action && _ctx.action != `toFree` && _ctx.paymentInfo && _ctx.paymentInfo.registered == false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _hoisted_38,
            _createVNode(_component_card, {
              class: _normalizeClass(["stripe-card", `roundForm w100 fl yu`]),
              stripe: _ctx.stripeKey,
              options: _ctx.stripeOptions,
              style: `padding:15px;`,
              onChange: _ctx.complete
            }, null, 8, ["stripe", "options", "onChange"]),
            _hoisted_39
          ]))
        : _createCommentVNode("", true),
      _hoisted_40,
      _hoisted_41,
      _hoisted_42,
      _createElementVNode("div", _hoisted_43, [
        (!_ctx.isSP)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissConfirmChangePlanModal && _ctx.dismissConfirmChangePlanModal(...args))),
              class: "pointer centered circle_button fs14 noborder",
              style: {"width":"120px","border-radius":"8px","padding":"11px 8px"}
            }, " キャンセル "))
          : _createCommentVNode("", true),
        _createElementVNode("p", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fixChangePlan && _ctx.fixChangePlan(...args))),
          class: "pointer centered circle_button skyblueBg fs14",
          style: {"width":"240px","border-radius":"8px","padding":"11px 8px"}
        }, [
          (_ctx.action && _ctx.action == `toFree`)
            ? (_openBlock(), _createElementBlock("span", _hoisted_44, "無料に変更"))
            : _createCommentVNode("", true),
          (_ctx.action && _ctx.action == `toPay`)
            ? (_openBlock(), _createElementBlock("span", _hoisted_45, "有料に変更"))
            : _createCommentVNode("", true),
          (_ctx.action && _ctx.action == `change`)
            ? (_openBlock(), _createElementBlock("span", _hoisted_46, "プランを変更"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isSP)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("p", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dismissConfirmChangePlanModal && _ctx.dismissConfirmChangePlanModal(...args))),
                class: "pointer centered circle_button fs14",
                style: {"width":"120px","border":"0","border-radius":"8px","padding":"11px 8px"}
              }, " キャンセル ")
            ]))
          : _createCommentVNode("", true),
        _hoisted_49
      ])
    ])
  ]))
}